import { render, staticRenderFns } from "./lectures.vue?vue&type=template&id=d564951c&scoped=true"
import script from "./lectures.vue?vue&type=script&lang=js"
export * from "./lectures.vue?vue&type=script&lang=js"
import style0 from "./lectures.vue?vue&type=style&index=0&id=d564951c&prod&scoped=true&lang=css"
import style1 from "./lectures.vue?vue&type=style&index=1&id=d564951c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d564951c",
  null
  
)

export default component.exports